module.exports = __webpack_public_path__ + "img/winer.ae1a2dfd.png";